import React from 'react';
import { Display, Heading, Body, Label } from '../components/Typography';
import Button from '../components/Button';

const ForOrganisations = () => {
  return (
    <div className="w-full bg-epoq-paper min-h-screen">
      <header className="py-24 px-6 lg:px-12 text-center max-w-4xl mx-auto">
        <Display className="mb-8">Capability built around <br/><span className="italic text-epoq-coral">your organisation.</span></Display>
        <Body large className="max-w-2xl mx-auto">
          Programmes can be adapted to ensure learning connects directly to your operational reality.
        </Body>
      </header>

      {/* Adaptation Grid - Art Directed */}
      <section className="py-12 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-epoq-blue/10 border border-epoq-blue/10">
            {['Roles', 'Departments', 'Industry', 'Existing tools', 'Internal policies', 'Business objectives', 'Workflows', 'Governance maturity'].map((item, i) => (
              <div key={i} className="bg-epoq-paper p-8 flex items-center justify-center text-center hover:bg-white transition-colors">
                <span className="font-serif text-xl md:text-2xl">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Three Stage Model */}
      <section className="py-32 px-6 lg:px-12 bg-epoq-blue text-epoq-white mt-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-12 lg:gap-8">
            
            <div className="relative border-t border-epoq-white/20 pt-8">
              <span className="absolute top-0 right-0 bg-epoq-lime text-epoq-blue text-xs font-bold px-2 py-1 transform -translate-y-1/2">STAGE 1</span>
              <h3 className="font-serif text-4xl mb-6">Discover</h3>
              <p className="opacity-80 leading-relaxed">Clarify goals, participants, workflows and current capability.</p>
            </div>

            <div className="relative border-t border-epoq-white/20 pt-8">
              <span className="absolute top-0 right-0 bg-epoq-lime text-epoq-blue text-xs font-bold px-2 py-1 transform -translate-y-1/2">STAGE 2</span>
              <h3 className="font-serif text-4xl mb-6">Design</h3>
              <p className="opacity-80 leading-relaxed">Adapt the programme, cases, exercises and learning materials.</p>
            </div>

            <div className="relative border-t border-epoq-white/20 pt-8">
              <span className="absolute top-0 right-0 bg-epoq-lime text-epoq-blue text-xs font-bold px-2 py-1 transform -translate-y-1/2">STAGE 3</span>
              <h3 className="font-serif text-4xl mb-6">Deliver</h3>
              <p className="opacity-80 leading-relaxed">Facilitate the learning, evaluate outcomes and identify practical next steps.</p>
            </div>

          </div>
        </div>
      </section>

      {/* Engagement Types */}
      <section className="py-32 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-center">
          <div className="lg:w-1/3">
            <Label className="mb-4 block text-epoq-coral">Formats</Label>
            <Heading>Possible engagement types</Heading>
          </div>
          <div className="lg:w-2/3 grid sm:grid-cols-2 gap-y-4 gap-x-8 font-serif text-2xl">
             <div className="border-b border-epoq-blue/10 py-4">Executive briefing</div>
             <div className="border-b border-epoq-blue/10 py-4">Team workshop</div>
             <div className="border-b border-epoq-blue/10 py-4">Closed company cohort</div>
             <div className="border-b border-epoq-blue/10 py-4">Capability programme</div>
             <div className="border-b border-epoq-blue/10 py-4">Workflow sprint</div>
             <div className="border-b border-epoq-blue/10 py-4">AI policy & literacy programme</div>
          </div>
        </div>
        
        <div className="text-center mt-24">
          <Button to="/contact" variant="primary" size="lg">Start a conversation</Button>
        </div>
      </section>

    </div>
  );
};

export default ForOrganisations;